'use strict';

var _ = require('lodash');
var TemplateSecondaryCriteriaController = function TemplateSecondaryCriteriaController($scope, elementServiceProvider, StrategyCondition, StrategyConstants) {
  $scope.templateSecondaryCriteriaElementService = elementServiceProvider.getInstance({
    preAddingNewElementHook: function preAddingNewElementHook() {
      $scope.setActiveElementService($scope.templateSecondaryCriteriaElementService);
      return true;
    },
    createNewElement: function createNewElement() {
      return new StrategyCondition({});
    },
    getCollection: function getCollection() {
      return $scope.templateStrategy && $scope.templateStrategy.commonConditions;
    },
    getSelectedRowType: function getSelectedRowType() {
      return StrategyConstants.CONDITION;
    },
    isDuplicable: function isDuplicable() {
      return true;
    },
    createCopyOf: function createCopyOf(element) {
      if (element instanceof StrategyCondition) {
        return element.createCopy();
      }
      return null;
    }
  });
  $scope.isRowSelectedTemplateSecondaryCriteria = $scope.templateSecondaryCriteriaElementService.isElementSelected;
  $scope.changeSelectedRowTemplateSecondaryCriteria = function (elem) {
    $scope.templateSecondaryCriteriaElementService.selectElement(elem);
    $scope.updateConditionCategories($scope.selectedLevel.domain);
    $scope.setActiveElementService($scope.templateSecondaryCriteriaElementService);
  };
  var isStatementBoxVisible = false;
  $scope.toggleStatementBox = function () {
    isStatementBoxVisible = !isStatementBoxVisible;
  };
  $scope.isStatementBoxVisible = function () {
    return isStatementBoxVisible && !$scope.isStatementEmpty();
  };
};
TemplateSecondaryCriteriaController.$inject = ['$scope', 'ElementServiceProvider', 'StrategyConditionFactory', 'StrategyConstants'];
module.exports = TemplateSecondaryCriteriaController;